import React, { useEffect } from 'react';
import { useCanvas } from '../context/canvasContext';
import DarkModeToggle, { useDarkMode } from './DarkModeToggle';

/**
 * Dark-mode switch in the header — milepad's animated sun/moon toggle, backed
 * by the same persisted preference the other apps read. `setMode` drives
 * darkreader for the page.
 */
function Modes() {
  const { dark } = useDarkMode();
  const { setMode } = useCanvas();
  useEffect(() => { setMode(dark); }, [dark, setMode]);

  return <DarkModeToggle />;
}

export default Modes;
